<template>
  <oie-my-machines-quick-add-slide-in id="my-machines-quick-add">
    <template #activator="{ open }">
      <oie-base-action theme="outlined" size="large" @click="quickAddMachine(open)">
        <template #iconPrepend>
          <oie-base-icon icon="bookmark" size="s"></oie-base-icon>
        </template>
        {{ tStatic('saveThisMachine') }}
      </oie-base-action>
    </template>
  </oie-my-machines-quick-add-slide-in>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('myMachines', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines']),
    ...mapGetters('ui', ['activeSlideIn'])
  },
  watch: {
    activeSlideIn(newVal, oldVal) {
      const closedThisSlideIn = oldVal === 'my-machines-quick-add' && !newVal
      if(closedThisSlideIn) {
        this.setCurrentMachine(null)
      }
    }
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    ...mapActions('myMachines', ['setCurrentMachine', 'getMyMachines', 'getMyMachinesMetaData']),
    quickAddMachine(open) {
      this.setCurrentMachine({ type: this.clientModel.currentVehicle.type, manufacturer: this.clientModel.currentVehicle.manufacturer, model: this.clientModel.currentVehicle.itemId })
      open()
    }
  }
}
</script>
